namespace $ {

	export class $shm_projects_config extends $mol_object2 {
		private static server_agent_token_cache: string | null = null

		static domain_suffix() {
			const location = this.$.$mol_dom_context.document?.location
			if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return '158-160-195-195.ip.hyoo.ru'
			}
			if( location?.protocol === 'https:' && location.hostname === 'dashboard.shmakov.media' ) {
				return '51-250-36-140.ip.hyoo.ru'
			}
			return ''
		}

		static preview_url( path: string, workspace_id = 'base' ) {
			const module = path.replace( /^\/+|\/+$/g, '' )
			if( !module ) return 'about:blank'
			const url = new URL( this.resource_url( `${ module }/-/test.html`, true, workspace_id ) )
			const token = this.agent_token()
			if( this.domain_suffix() && token ) {
				url.searchParams.delete( 'token' )
				url.searchParams.delete( 'hitalama_direct' )
				url.pathname = `/__hitalama_tunnel/${ encodeURIComponent( token ) }${ url.pathname }`
			}
			return url.toString()
		}

		static resource_url( path: string, direct = true, workspace_id = 'base' ) {
			if( /^(?:https?:|data:|blob:)/.test( path ) ) return path
			const resource = path.replace( /^\/+/, '' )
			if( !resource ) return ''
			if( resource.startsWith( 'shm/projects/.dev/artifacts/' ) ) {
				const url = new URL( this.projects_api_url() )
				url.searchParams.set( 'artifact', resource )
				const token = this.agent_token()
				if( token ) url.searchParams.set( 'token', token )
				return url.toString()
			}
			const suffix = this.domain_suffix()
			const host = suffix ? `https://devserver.${ suffix }` : 'http://localhost:9094'
			const workspace = encodeURIComponent( workspace_id || 'base' )
			const url = new URL( `/workspace/${ workspace }/${ resource }`, host )
			const token = this.agent_token()
			if( suffix && token ) {
				url.searchParams.set( 'token', token )
				if( direct ) url.searchParams.set( 'hitalama_direct', '1' )
			}
			return url.toString()
		}

		static projects_api_url() {
			const overridden = this.$.$mol_state_local.value< string >( '$shm_projects_api_base' )
				?? this.$.$mol_state_local.value< string >( '$shm_projects_goal_api_base' )
			if( overridden ) return overridden
			const suffix = this.domain_suffix()
			return suffix ? `https://projects-dev.${ suffix }/` : 'http://127.0.0.1:9092/'
		}

		static server_agent_token() {
			const location = this.$.$mol_dom_context.document?.location
			if( location?.protocol !== 'https:' || !location.hostname.includes( '158-160-195-195' ) ) return ''
			if( this.server_agent_token_cache !== null ) return this.server_agent_token_cache
			return this.server_agent_token_cache = this.$.$mol_fetch.text( '/hitalama_tunnel_token' ).trim()
		}

		static agent_token() {
			const server = this.server_agent_token()
			if( server ) return server

			const scope = $ as any
			const ba_pb = scope.$shm_ba_pb as undefined | {
				auth_user_token?: ()=> string
				user_agent_token?: ()=> string
			}
			if( ba_pb?.auth_user_token?.() ) {
				const user_token = String( ba_pb.user_agent_token?.() ?? '' ).trim()
				if( user_token ) return user_token
			}

			const settings = scope.$shm_hitalama_settings as undefined | {
				agent_token?: ()=> string
			}
			const shared = String( settings?.agent_token?.() ?? '' ).trim()
			if( shared ) return shared

			return String(
				this.$.$mol_state_local.value< string >( 'hitalama_agent_token' )
					?? this.$.$mol_state_local.value< string >( '$shm_projects_agent_token' )
					?? ''
			).trim()
		}

	}

}
